export * from './primeNGDataTableODataQueryExtensions';



// WEBPACK FOOTER //
// ./~/tslint-loader?emitErrors=true&failOnHint=true!./src/index.ts